import { useContext, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import showhide from "../../Assets/ShowHide.svg";
import DotsVertical from '../../Assets/OrderManagement/DotsVertical.svg';
import { useOutsideClickForTwoRef } from '../../Hooks/useOutsideClickForTwoRef';
import TickMark from '../../Assets/Modals/TickMark.svg';
import KebabMenu from './KebabMenu';
import { closeCollectionKebabMenu, fetchCategoryCollections, openCollectionKebabMenu } from '../../Features/collectionsSlice';
import { CategoryCollectionContext } from '../../Context/Collections/CategoryCollectionContext';
import { updateCategoryCollection } from '../../lib/utils/apiCalls';
import { getCachedMediaUrl } from '../../lib/utils/utils';
import { showToast } from '../../Components/Toaster/Toaster';

function CollectionBar({ collection, isSelected, duration }) {
    const params = useParams();
    const dispatch = useDispatch();
    const location = useLocation();

    const kebabRef = useRef(null);
    const kebabButtonRef = useRef(null);

    useOutsideClickForTwoRef(kebabRef, kebabButtonRef, () => {
        dispatch(closeCollectionKebabMenu());
    });

    const { selectedCategoryCollections, setSelectedCategoryCollections } = useContext(CategoryCollectionContext);

    const kebabCollectionId = useSelector((state) => state.collections.collectionKebab.collectionId);

    const handleToggleClick = async () => {
        let visibilityValue;

        if(collection.isVisible) {
            visibilityValue = false;
        }
        else {
            visibilityValue = true;
        }

        try {
            let callData = {
                isVisible: visibilityValue
            }

            const response = await updateCategoryCollection(callData, collection.id);
            if(response?.status === 200) {
                try {
                    dispatch(fetchCategoryCollections(params.categoryId));
                }
                catch(err) {
                    console.log(err);
                }
            }
            else {
                showToast('Error updating category visibility.', 'error');
            }
        }
        catch(err) {
            showToast('Error updating category visibility.', 'error');
        }
    }

    const handleSelectBoxClick = () => {
        if(selectedCategoryCollections.includes(collection.id)) {
            const filteredList = selectedCategoryCollections.filter(item => item !== collection.id);
            setSelectedCategoryCollections(filteredList);
        }
        else {
            setSelectedCategoryCollections([ ...selectedCategoryCollections, collection.id ]);
        }
    }

    const handleOpenKebab = () => {
        if(kebabCollectionId === collection.id) {
            dispatch(closeCollectionKebabMenu());
        }
        else {
            dispatch(openCollectionKebabMenu(collection.id));
        }
    }

    return (
        <div className="flex items-center bg-[#FFFFFF] border-t text-[#121212] font-normal border-[#EAEAEA] select-none">
            <div className="flex items-center gap-2 w-[calc((54/100)*(100%-44px))] px-[10px] py-[6px]">
                <div onClick={handleSelectBoxClick} className={`cursor-pointer size-6 flex items-center justify-center rounded-md border ${isSelected ? 'border-none bg-primaryAccent' : 'border-[#D1D5DB]'} `} >
                    <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                </div>

                <Link to={`${location.pathname}/collection/${collection.id}`} className="w-[calc(100%-32px)] flex items-center gap-2">
                    {
                        collection.CollectionImgUrl.length > 0 ? 
                        <div className="size-16 flex items-center justify-center rounded-lg overflow-hidden">
                            <img className='size-full object-cover' src={getCachedMediaUrl(collection.CollectionImgUrl[0])} alt="" />
                        </div> : 
                        <div className="size-16 rounded-lg bg-[#EAEAEA]"></div>
                    }

                    <h1 className='font-semibold text-[14px] leading-6 text-[#121212] w-[calc(100%-64px)] whitespace-nowrap overflow-hidden text-ellipsis'>{collection.CollectionName}</h1>
                </Link>
            </div>

            <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">{collection.productCount}</h2>

            <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[26px] text-[14px] leading-6">{duration ? `${duration} days left` : 'Off'}</h2>

            <div className="w-[calc((10/100)*(100%-44px))] px-[10px] py-[26px]">
                <button onClick={handleToggleClick} className={`outline-none flex items-center w-11 h-6 p-[2px] rounded-xl ${collection.isVisible ? 'bg-[#4F46E5]' : 'bg-[#E5E7EB]'}`}>
                    <img className={`${collection.isVisible ? 'ml-auto mr-[-2px]' : 'ml-[-2px]'} rounded-full`} src={showhide} alt="" />
                </button>
            </div>

            <div className="w-11 flex items-center justify-center">
                {
                    selectedCategoryCollections?.length === 0 && 
                    <div onClick={handleOpenKebab} ref={kebabButtonRef} className='relative w-full py-[26px] flex items-center justify-center outline-none cursor-pointer'>
                        <img src={DotsVertical} alt="" />

                        {
                            kebabCollectionId === collection.id && 
                            <KebabMenu 
                                boxRef={kebabRef} 
                                collection={collection} 
                            />
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default CollectionBar;
